import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const HIGHLIGHT_PALETTE = [
    { name: "sage", value: "#B7CDB1" },
    { name: "amber", value: "#E7C36F" },
    { name: "plum", value: "#C7A0B0" },
    { name: "slate", value: "#9CB0C0" },
    { name: "clay", value: "#D8B49E" },
];


// Reader
export const fetchChapters = () => axios.get(`${API}/chapters`).then(r => r.data);
export const fetchChapter = (ch) => axios.get(`${API}/chapter/${ch}`).then(r => r.data);
export const fetchVerseGreek = (ch, vs) => axios.get(`${API}/verse/${ch}/${vs}/greek`).then(r => r.data);
export const fetchWord = (strongs, morph) =>
    axios.get(`${API}/word`, { params: { strongs, morph } }).then(r => r.data);
export const search = (q, version = "kjv") =>
    axios.get(`${API}/search`, { params: { q, version } }).then(r => r.data);
export const fetchMeta = () => axios.get(`${API}/meta`).then(r => r.data);

// Categories
export const fetchCategories = (space) =>
    axios.get(`${API}/categories`, { params: { space } }).then(r => r.data);
export const createCategory = (payload) =>
    axios.post(`${API}/categories`, payload).then(r => r.data);
export const updateCategory = (id, payload) =>
    axios.put(`${API}/categories/${id}`, payload).then(r => r.data);
export const deleteCategory = (id) =>
    axios.delete(`${API}/categories/${id}`).then(r => r.data);

// Prayer subjects
export const listSubjects = (params = {}) =>
    axios.get(`${API}/prayer-subjects`, { params }).then(r => r.data);
export const createSubject = (name) =>
    axios.post(`${API}/prayer-subjects`, { name }).then(r => r.data);
export const getSubject = (id) => axios.get(`${API}/prayer-subjects/${id}`).then(r => r.data);
export const updateSubject = (id, payload) =>
    axios.put(`${API}/prayer-subjects/${id}`, payload).then(r => r.data);
export const togglePin = (id) =>
    axios.post(`${API}/prayer-subjects/${id}/pin`).then(r => r.data);
export const moveToKept = (id) =>
    axios.post(`${API}/prayer-subjects/${id}/kept`).then(r => r.data);
export const returnToActive = (id) =>
    axios.post(`${API}/prayer-subjects/${id}/return-active`).then(r => r.data);

// Highlights
export const listHighlights = (params = {}) =>
    axios.get(`${API}/highlights`, { params }).then(r => r.data);
export const createHighlight = (refs, color) =>
    axios.post(`${API}/highlights`, { refs, color }).then(r => r.data);
export const deleteHighlights = (refs) =>
    axios.delete(`${API}/highlights`, { params: { refs: refs.join(",") } }).then(r => r.data);

// Bookmarks
export const listBookmarks = () =>
    axios.get(`${API}/bookmarks`).then(r => r.data);
export const createBookmark = (refs, note = "", groups = []) =>
    axios.post(`${API}/bookmarks`, { refs, note, groups }).then(r => r.data);
export const deleteBookmarksByRefs = (refs) =>
    axios.delete(`${API}/bookmarks`, { params: { refs: refs.join(",") } }).then(r => r.data);
export const updateBookmark = (id, payload) =>
    axios.patch(`${API}/bookmarks/${id}`, payload).then(r => r.data);
export const listBookmarkGroups = () =>
    axios.get(`${API}/bookmark-groups`).then(r => r.data);

// Goals
export const listGoalCategories = () =>
    axios.get(`${API}/goals/categories`).then(r => r.data);
export const listGoals = (status = "") =>
    axios.get(`${API}/goals`, { params: status ? { status } : {} }).then(r => r.data);
export const getGoal = (id) =>
    axios.get(`${API}/goals/${id}`).then(r => r.data);
export const createGoal = (payload) =>
    axios.post(`${API}/goals`, payload).then(r => r.data);
export const updateGoal = (id, payload) =>
    axios.patch(`${API}/goals/${id}`, payload).then(r => r.data);
export const deleteGoal = (id) =>
    axios.delete(`${API}/goals/${id}`).then(r => r.data);
export const checkinGoal = (id, payload = {}) =>
    axios.post(`${API}/goals/${id}/checkin`, payload).then(r => r.data);
export const updateCheckin = (goalId, checkinId, payload) =>
    axios.patch(`${API}/goals/${goalId}/checkin/${checkinId}`, payload).then(r => r.data);
export const deleteCheckin = (goalId, checkinId) =>
    axios.delete(`${API}/goals/${goalId}/checkin/${checkinId}`).then(r => r.data);
export const goalEncouragement = (category, theme = "", cursor = 0) =>
    axios.get(`${API}/goals/encouragement`, { params: { category, theme, cursor } }).then(r => r.data);
export const listQuantityLogs = (goalId, date = "") =>
    axios.get(`${API}/goals/${goalId}/logs`, { params: date ? { date } : {} }).then(r => r.data);
export const listQuantityHistory = (goalId) =>
    axios.get(`${API}/goals/${goalId}/logs/history`).then(r => r.data);
export const createQuantityLog = (goalId, amount, extras = {}) =>
    axios.post(`${API}/goals/${goalId}/logs`, { amount, ...extras }).then(r => r.data);
export const updateQuantityLog = (goalId, logId, payload) =>
    axios.patch(`${API}/goals/${goalId}/logs/${logId}`, payload).then(r => r.data);
export const deleteQuantityLog = (goalId, logId) =>
    axios.delete(`${API}/goals/${goalId}/logs/${logId}`).then(r => r.data);


// Passage builder
export const buildPassage = (refs, version = "kjv") =>
    axios.post(`${API}/passage`, { refs, version }).then(r => r.data);

// Bible questions (QuestionGod)
export const fetchQuestionsForChapter = (book, ch) =>
    axios.get(`${API}/questions/chapter/${book}/${ch}`).then(r => r.data);
export const fetchQuestionsForVerse = (book, ch, vs) =>
    axios.get(`${API}/questions/verse/${book}/${ch}/${vs}`).then(r => r.data);
export const fetchQuestionOfTheDay = () =>
    axios.get(`${API}/questions/today`).then(r => r.data);

// Settings
export const getSettings = () => axios.get(`${API}/settings`).then(r => r.data);
export const putSettings = (payload) => axios.put(`${API}/settings`, payload).then(r => r.data);

// Journal
export const listJournal = (params = {}) =>
    axios.get(`${API}/journal`, { params }).then(r => r.data);
export const createJournal = (payload) =>
    axios.post(`${API}/journal`, payload).then(r => r.data);
export const getJournal = (id) => axios.get(`${API}/journal/${id}`).then(r => r.data);
export const updateJournal = (id, payload) =>
    axios.put(`${API}/journal/${id}`, payload).then(r => r.data);
export const deleteJournal = (id) => axios.delete(`${API}/journal/${id}`).then(r => r.data);

// Notes
export const listNotes = (params = {}) =>
    axios.get(`${API}/notes`, { params }).then(r => r.data);
export const createNote = (payload) =>
    axios.post(`${API}/notes`, payload).then(r => r.data);
export const getNote = (id) => axios.get(`${API}/notes/${id}`).then(r => r.data);
export const updateNote = (id, payload) =>
    axios.put(`${API}/notes/${id}`, payload).then(r => r.data);
export const deleteNote = (id) => axios.delete(`${API}/notes/${id}`).then(r => r.data);

// @ engine
export const resolveMention = (q, space, version = "kjv") =>
    axios.get(`${API}/mention/resolve`, { params: { q, space, version } }).then(r => r.data);
export const dismissName = (name) =>
    axios.post(`${API}/mention/dismiss-name`, { name }).then(r => r.data);
